import { useIndexStore } from "@/state/user/useUserStore";
import useUserStore from "@/state/user/useUserStore";
import { m } from "motion/react";
import React, { useRef } from "react";
import { ScrollView } from "react95";
import { X } from "lucide-react";
import { AnimatePresence } from "motion/react";
import { MobileHoverBtn } from "@/components/styles";
import NextImage from "next/image";

const UploadComponent = ({
  parentVariants,
  childVariants,
  color,
}: {
  parentVariants: any;
  childVariants: any;
  color: string;
}) => {
  const [
    tabs,
    setTabs,
    setAssets,
    textFields,
    addTextField,
    restrictedFonts,
    uploadAssets,
    ratio,
    selectedAssets,
    setUploadAssets,
  ] = useUserStore((state) => [
    state.tabs,
    state.setTabs,
    state.setAssets,
    state.textFields,
    state.addTextField,
    state.restrictedFonts,
    state.uploadAssets,
    state.ratio,
    state.assets,
    state.setUploadAssets,
  ]);

  const [
    lastAssetIndex,
    setLastAssetIndex,
    lastTextFieldIndex,
    setLastTextFieldIndex,
    lastUploadAssetIndex,
    setLastUploadAssetIndex,
  ] = useIndexStore((state) => [
    state.lastAssetIndex,
    state.setLastAssetIndex,
    state.lastTextFieldIndex,
    state.setLastTextFieldIndex,
    state.lastUploadAssetIndex,
    state.setLastUploadAssetIndex,
  ]);

  const allFieldsLength =
    textFields.length + selectedAssets.length + uploadAssets.length;

  const setAssetsHandler = (img: string) => {
    const id = crypto.randomUUID();
    setAssets((currentAssets) => [
      ...currentAssets,
      {
        id: id,
        img: img,
        flipHorizontal: false,
        flipVertical: false,
        zIndex: allFieldsLength + 1,
        index: lastAssetIndex + 1,
      },
    ]);
    setLastAssetIndex(lastAssetIndex + 1);
  };

  const fileAssetInputRef = useRef<HTMLInputElement>(null);

  const handleUploadAssetContainer = () => {
    if (fileAssetInputRef.current !== null) {
      fileAssetInputRef.current.click();
    }
  };

  const handleAssetUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files !== null) {
      const file = event.target.files[0];
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const ratio = width / height;
        const id = crypto.randomUUID();
        setUploadAssets([
          ...uploadAssets,
          {
            id: id,
            img: URL.createObjectURL(file),
            ratio,
            flipHorizontal: false,
            flipVertical: false,
            zIndex: allFieldsLength + 1,
            index: lastUploadAssetIndex + 1,
          },
        ]);
        setLastUploadAssetIndex(lastUploadAssetIndex + 1);
      };
      if (file instanceof File) {
        img.src = URL.createObjectURL(file);
      }
    }
  };

  return (
    <>
      <m.div
        variants={parentVariants}
        initial="initial"
        animate="animate"
        style={{
          background: "#cccccc",
          boxSizing: "border-box",
          borderRadius: "0.25rem",
          border: "4px solid #000000",
          boxShadow: "2px 2px 0px 0px #000000",
          maxHeight: "calc(100% - 60px)",
        }}
      >
        <m.div
          style={{
            background: color,
            boxSizing: "border-box",
            padding: "8px 8px 8px 8px",
            borderBottom: "4px solid #000000",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              padding: "0 8px",
            }}
          >
            <p
              style={{
                margin: 0,
                fontFamily: "var(--font-cabin-condensed)",
                fontSize: "20px",
                height: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                color: "#000",
              }}
            >
              Upload
            </p>
          </div>
        </m.div>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: `calc(100% - 68px)`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "start",
            boxSizing: "border-box",
          }}
        >
          <ScrollView
            style={{
              height: "100%",
              maxHeight: "calc(100% - 80px)",
              margin: "0",
              padding: "0",
              width: "100%",
            }}
          >
            <m.div
              variants={childVariants}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                padding: "24px",
                gap: "8px",
                boxSizing: "border-box",
              }}
            >
              <AnimatePresence>
                {uploadAssets.map((asset: any) => (
                  <m.div
                    key={asset.id}
                    exit={{ opacity: 0, transition: { duration: 0.15 } }}
                    transition={{ duration: 0.2 }}
                    layout
                    style={{
                      width: "100%",
                      height: "96px",
                      padding: "8px 12px",
                      boxSizing: "border-box",
                      boxShadow: "2px 2px 0px 0px #000000",
                      border: "4px solid #000000",
                      borderRadius: "0.25rem",
                      position: "relative",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      background: "#cccccc",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          aspectRatio: "1/1",
                          position: "relative",
                          padding: "8px",
                          boxSizing: "border-box",
                          marginRight: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            position: "relative",
                          }}
                        >
                          <NextImage
                            src={asset.img}
                            alt={asset.id}
                            fill
                            style={{
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          maxWidth: "96px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Upload {asset.index}
                      </div>
                    </div>
                    <div>
                      <MobileHoverBtn
                        whileHover={{
                          scale: 1.03,
                          transition: {
                            duration: 0.15,
                            ease: "linear",
                          },
                        }}
                        whileTap={{ scale: 0.98 }}
                        color={color}
                        onClick={() =>
                          setUploadAssets(
                            uploadAssets.filter((a) => a.id !== asset.id)
                          )
                        }
                      >
                        <X style={{ width: "16px", height: "16px" }} />
                      </MobileHoverBtn>
                    </div>
                  </m.div>
                ))}
              </AnimatePresence>
            </m.div>
          </ScrollView>
          <div
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "1rem",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <m.div
              style={{
                width: "100%",
                height: "3rem",
                background: color,
                display: "flex",
                boxSizing: "border-box",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                borderRadius: "0.25rem",
                color: "black",
                fontFamily: "var(--font-cabin-condensed)",
                fontSize: "1rem",
                border: "4px solid #000000",
                boxShadow: "2px 2px 0px 0px #000000",
              }}
              whileHover={{
                scale: 1.01,
                transition: {
                  duration: 0.15,
                  ease: "linear",
                },
              }}
              whileTap={{ scale: 0.99 }}
              onClick={handleUploadAssetContainer}
            >
              Upload Asset
              <input
                type="file"
                accept="image/*"
                ref={fileAssetInputRef}
                style={{ display: "none" }}
                onChange={handleAssetUpload}
              />
            </m.div>
          </div>
        </div>
      </m.div>
    </>
  );
};

export default UploadComponent;
